import { IconBox } from './IconBox';

export const SocialMediaIconCollection = () => {
  const badgeText = {
    new: 'neu',
    update: 'updated',
  };

  return (
    <>
      <h2>Social Media Icons</h2>
      <div className="icons">
        <div className="row mb-5 g-4">
          <IconBox
            hasBadge={false}
            iconClass="icon__youtube--md"
            iconLabel="Youtube"
          />

          <IconBox
            hasBadge={false}
            iconClass="icon__facebook--md"
            iconLabel="Facebook"
          />

          <IconBox
            hasBadge={false}
            iconClass="icon__flickr--md"
            iconLabel="Flickr"
          />

          <IconBox
            hasBadge={true}
            badgeText={badgeText.new}
            iconClass="icon__bluesky--md"
            iconLabel="Bluesky"
          />

          <IconBox
            hasBadge={false}
            iconClass="icon__instagram--md"
            iconLabel="Instagram"
          />

          <IconBox
            hasBadge={false}
            iconClass="icon__issuu--md"
            iconLabel="Issuu"
          />

          <IconBox
            hasBadge={false}
            badgeText={badgeText.update}
            iconClass="icon__itunes--md"
            iconLabel="iTunes"
          />

          <IconBox
            hasBadge={false}
            iconClass="icon__linkedin--md"
            iconLabel="LinkedIn"
          />

          <IconBox
            hasBadge={false}
            iconClass="icon__vimeo--md"
            iconLabel="Vimeo"
          />

          <IconBox
            hasBadge={false}
            iconClass="icon__tiktok--md"
            iconLabel="Tiktok"
          />

          <IconBox
            hasBadge={false}
            iconClass="icon__snapchat--md"
            iconLabel="Snapchat"
          />

          <IconBox
            hasBadge={false}
            iconClass="icon__xing--md"
            iconLabel="Xing"
          />

          <IconBox
            hasBadge={false}
            iconClass="icon__switch--md"
            iconLabel="Switch"
          />
        </div>

        <h2>Footer Share Icons</h2>
        <div className="row mb-5 pt-4 g-2 bg-black">
          <IconBox
            hasBadge={false}
            iconBoxBg="bg-black"
            iconClass="icon__facebook--sm"
            iconLabel="Facebook"
          />

          <IconBox
            hasBadge={false}
            iconBoxBg="bg-black"
            iconClass="icon__xing--sm"
            iconLabel="Xing"
          />

          <IconBox
            hasBadge={true}
            iconBoxBg="bg-black"
            iconClass="icon__bluesky--sm"
            iconLabel="Bluesky"
          />

          <IconBox
            hasBadge={false}
            iconBoxBg="bg-black"
            iconClass="icon__instagram--sm"
            iconLabel="Instagram"
          />

          <IconBox
            hasBadge={false}
            iconBoxBg="bg-black"
            iconClass="icon__linkedin--sm"
            iconLabel="LinkedIn"
          />

          <IconBox
            hasBadge={false}
            iconBoxBg="bg-black"
            iconClass="icon__youtube--sm"
            iconLabel="Youtube"
          />

          <IconBox
            hasBadge={false}
            iconBoxBg="bg-black"
            iconClass="icon__tiktok--sm"
            iconLabel="Tiktok"
          />

          <IconBox
            hasBadge={false}
            iconBoxBg="bg-black"
            iconClass="icon__snapchat--sm"
            iconLabel="Snapchat"
          />

          <IconBox
            hasBadge={false}
            iconBoxBg="bg-black"
            iconClass="icon__vimeo--sm"
            iconLabel="Vimeo"
          />
        </div>
      </div>
    </>
  );
};

export default SocialMediaIconCollection;
